import React from 'react';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Button as RMDButton } from 'react-md';
import { get } from 'lodash-es';

import ValidationMessage from '../../Common/ValidationMessage';

const PanelManager = ({
  expanded,
  toggleExpanded,
  strings,
  handleSubscribe,
  handleCancel,
  classes,
  actionsState,
  readOnly,
  children,
  validate,
}) => {
  const subscribeLabel = get(strings, 'block.transform.btn.subscribe.label');
  const cancelLabel = get(strings, 'block.transform.btn.cancel.label');

  return (
    <ExpansionPanel
      className={`expansion-panel ${expanded ? 'expanded' : ''}`}
      expanded={expanded}
      onChange={toggleExpanded}
    >
      <ExpansionPanelSummary
        className="expansion-panel-summary"
        expandIcon={<ExpandMoreIcon className="expansion-more-icon" />}
      >
        <span className="extra-block-title">{get(strings, 'block.transform.title')}</span>
        {/* {summary(values.extra)} */}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>
        <div className="subscriptions">
          {/*  One Subscription per covered element */}
          {children}
        </div>
      </ExpansionPanelDetails>
      <Divider />
      <ExpansionPanelActions className="block actions">
        <div className="button-block">
          <RMDButton
            raised
            className="danger action-subscribe"
            secondary
            iconBefore={false}
            // swapTheming
            iconChildren="check_circle_outline"
            onClick={handleSubscribe}
            disabled={get(actionsState, 'btn.subscribe.disable', readOnly)}
            title={get(actionsState, 'btn.subscribe.message', subscribeLabel)}
          >
            {subscribeLabel}
          </RMDButton>
          <RMDButton
            raised
            className="danger action-cancel"
            iconBefore={false}
            swapTheming
            iconChildren="cancel"
            onClick={handleCancel}
            disabled={get(actionsState, 'btn.cancel.disable', readOnly)}
            title={get(actionsState, 'btn.cancel.message', cancelLabel)}
          >
            {cancelLabel}
          </RMDButton>
        </div>
        <ValidationMessage validate={validate} path="subscription" />
      </ExpansionPanelActions>
    </ExpansionPanel>
  );
};

PanelManager.propTypes = {
  strings: PropTypes.objectOf(PropTypes.string),
  formApi: PropTypes.any, // eslint-disable-line
  formState: PropTypes.any, // eslint-disable-line
  expanded: PropTypes.bool.isRequired,
  toggleExpanded: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  actionsState: PropTypes.any.isRequired, // eslint-disable-line
  handleSubscribe: PropTypes.func.isRequired,
  classes: PropTypes.any.isRequired, // eslint-disable-line
  onSubscribe: PropTypes.func, // eslint-disable-line
  onCancel: PropTypes.func, // eslint-disable-line
  readOnly: PropTypes.bool.isRequired,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  validate: PropTypes.object.isRequired, // eslint-disable-line
};

PanelManager.defaultProps = {
  strings: {},
};

export default PanelManager;
